/**
 * Base de dados de profissões para páginas SEO programáticas
 * Usado pelo componente MeiProfissaoPage.js
 * 
 * Para adicionar novas profissões, basta adicionar um novo objeto ao profissoesData
 */

export const profissoesData = {
  // =====================================================
  // BELEZA E ESTÉTICA
  // =====================================================
  'cabeleireiro': {
    titulo: 'Cabeleireiro',
    descricao: 'Profissional especializado em cortes, coloração, tratamentos capilares e penteados',
    cnae: '9602-5/01',
    cnaes_secundarios: ['9602-5/02'],
    categoria: 'Beleza e Estética',
    faturamento_medio: 'R$ 4.000 a R$ 12.000/mês',
    investimento_inicial: 'R$ 5.000 a R$ 30.000',
    servicos: ['Corte de cabelo', 'Coloração', 'Escova', 'Tratamentos capilares', 'Penteados'],
    equipamentos: ['Tesouras profissionais', 'Secador', 'Prancha', 'Cadeira de salão', 'Espelho'],
    dicas: [
      'Invista em cursos de especialização para aumentar seu ticket médio',
      'Mantenha um portfólio atualizado nas redes sociais',
      'Ofereça pacotes de serviços para fidelizar clientes'
    ],
    faq: [
      { p: 'Cabeleireiro pode ser MEI?', r: 'Sim! Cabeleireiro é uma das atividades permitidas para MEI sob o CNAE 9602-5/01.' },
      { p: 'Quanto custa o DAS de cabeleireiro MEI?', r: 'O DAS do MEI cabeleireiro é o valor padrão do MEI para prestadores de serviço, atualmente R$ 75,90/mês.' },
      { p: 'Cabeleireiro MEI pode ter funcionário?', r: 'Sim! O MEI pode contratar até 1 funcionário que receba até 1 salário mínimo ou o piso da categoria.' }
    ]
  },
  
  'cabeleireira': {
    titulo: 'Cabeleireira',
    descricao: 'Profissional especializada em cortes, coloração, tratamentos capilares e penteados',
    cnae: '9602-5/01',
    cnaes_secundarios: ['9602-5/02'],
    categoria: 'Beleza e Estética',
    faturamento_medio: 'R$ 4.000 a R$ 12.000/mês',
    investimento_inicial: 'R$ 5.000 a R$ 30.000',
    servicos: ['Corte de cabelo', 'Coloração', 'Escova', 'Tratamentos capilares', 'Penteados'],
    equipamentos: ['Tesouras profissionais', 'Secador', 'Prancha', 'Cadeira de salão', 'Espelho'],
    dicas: [
      'Invista em cursos de especialização para aumentar seu ticket médio',
      'Mantenha um portfólio atualizado nas redes sociais',
      'Ofereça pacotes de serviços para fidelizar clientes'
    ],
    faq: [
      { p: 'Cabeleireira pode ser MEI?', r: 'Sim! Cabeleireira é uma das atividades permitidas para MEI sob o CNAE 9602-5/01.' },
      { p: 'Quanto custa o DAS de cabeleireira MEI?', r: 'O DAS do MEI cabeleireira é o valor padrão do MEI para prestadores de serviço, atualmente R$ 75,90/mês.' },
      { p: 'Cabeleireira MEI pode ter funcionário?', r: 'Sim! O MEI pode contratar até 1 funcionário que receba até 1 salário mínimo ou o piso da categoria.' }
    ]
  },
  
  'barbeiro': {
    titulo: 'Barbeiro',
    descricao: 'Especialista em cortes masculinos, barba, bigode e tratamentos para homens',
    cnae: '9602-5/01',
    cnaes_secundarios: ['9602-5/02'],
    categoria: 'Beleza e Estética',
    faturamento_medio: 'R$ 3.000 a R$ 10.000/mês',
    investimento_inicial: 'R$ 3.000 a R$ 20.000',
    servicos: ['Corte masculino', 'Barba', 'Bigode', 'Sobrancelha', 'Hidratação'],
    equipamentos: ['Máquina de corte', 'Navalha', 'Cadeira de barbeiro', 'Tesoura', 'Produtos para barba'],
    dicas: [
      'Crie uma identidade visual forte para sua barbearia',
      'Ofereça cervejas e ambiente masculino diferenciado',
      'Invista em cursos de barbeiro para técnicas modernas'
    ],
    faq: [
      { p: 'Barbeiro pode ser MEI?', r: 'Sim! Barbeiro se enquadra no CNAE 9602-5/01 e pode ser MEI normalmente.' },
      { p: 'Preciso de alvará para abrir barbearia como MEI?', r: 'Depende da cidade. O MEI tem dispensa de alvará em muitos casos.' },
      { p: 'Quanto fatura em média um barbeiro MEI?', r: 'Um barbeiro MEI bem posicionado pode faturar entre R$ 3.000 e R$ 10.000 por mês.' }
    ]
  },
  
  'manicure': {
    titulo: 'Manicure',
    descricao: 'Profissional de estética das unhas das mãos e pés',
    cnae: '9602-5/02',
    cnaes_secundarios: ['9602-5/01'],
    categoria: 'Beleza e Estética',
    faturamento_medio: 'R$ 2.500 a R$ 8.000/mês',
    investimento_inicial: 'R$ 1.500 a R$ 10.000',
    servicos: ['Manicure', 'Pedicure', 'Esmaltação em gel', 'Alongamento', 'Nail art'],
    equipamentos: ['Kit de manicure', 'Cabine UV/LED', 'Alicates', 'Lixas', 'Esmaltes profissionais'],
    dicas: [
      'Especialize-se em técnicas como alongamento e nail art',
      'Crie perfil no Instagram mostrando seus trabalhos',
      'Ofereça combos manicure + pedicure com desconto'
    ],
    faq: [
      { p: 'Manicure pode ser MEI?', r: 'Sim! Manicure e pedicure estão no CNAE 9602-5/02, permitido para MEI.' },
      { p: 'Manicure MEI precisa emitir nota fiscal?', r: 'Para pessoas físicas é opcional, mas para empresas é obrigatório.' },
      { p: 'Quanto custa abrir MEI de manicure?', r: 'Abrir o MEI é gratuito. Você paga apenas o DAS mensal de aproximadamente R$ 75,90.' }
    ]
  },
  
  'maquiador': {
    titulo: 'Maquiador(a)',
    descricao: 'Profissional especializado em maquiagem social, artística e para eventos',
    cnae: '9602-5/02',
    cnaes_secundarios: [],
    categoria: 'Beleza e Estética',
    faturamento_medio: 'R$ 3.000 a R$ 15.000/mês',
    investimento_inicial: 'R$ 2.000 a R$ 15.000',
    servicos: ['Maquiagem social', 'Maquiagem para noivas', 'Maquiagem artística', 'Curso de automaquiagem'],
    equipamentos: ['Kit de maquiagem profissional', 'Pincéis', 'Iluminação', 'Espelho profissional'],
    dicas: [
      'Monte um portfólio profissional com fotos de alta qualidade',
      'Especialize-se em maquiagem para noivas (ticket alto)',
      'Ofereça cursos de automaquiagem como renda extra'
    ],
    faq: [
      { p: 'Maquiador pode ser MEI?', r: 'Sim! Atividades de maquiagem se enquadram no CNAE 9602-5/02.' },
      { p: 'Quanto cobra um maquiador MEI?', r: 'Valores variam de R$ 100 (social) até R$ 800+ (noivas).' },
      { p: 'Maquiador MEI pode dar curso?', r: 'Sim, pode ministrar cursos livres como MEI.' }
    ]
  },
  
  'esteticista': {
    titulo: 'Esteticista',
    descricao: 'Profissional de tratamentos estéticos faciais e corporais',
    cnae: '9602-5/02',
    cnaes_secundarios: [],
    categoria: 'Beleza e Estética',
    faturamento_medio: 'R$ 3.500 a R$ 12.000/mês',
    investimento_inicial: 'R$ 5.000 a R$ 30.000',
    servicos: ['Limpeza de pele', 'Peeling', 'Massagem', 'Drenagem linfática', 'Tratamentos corporais'],
    equipamentos: ['Maca', 'Vapor de ozônio', 'Alta frequência', 'Produtos profissionais'],
    dicas: [
      'Invista em certificações e cursos reconhecidos',
      'Ofereça pacotes de tratamento para fidelização',
      'Mantenha ambiente limpo e acolhedor'
    ],
    faq: [
      { p: 'Esteticista pode ser MEI?', r: 'Sim! Estética facial e corporal se enquadram no CNAE 9602-5/02.' },
      { p: 'Preciso de curso para ser esteticista MEI?', r: 'Não é obrigatório pelo MEI, mas cursos são essenciais para exercer a profissão.' },
      { p: 'Esteticista MEI pode fazer procedimentos invasivos?', r: 'Não. Procedimentos invasivos requerem formação superior.' }
    ]
  },

  // =====================================================
  // ALIMENTAÇÃO
  // =====================================================
  'confeiteiro': {
    titulo: 'Confeiteiro(a)',
    descricao: 'Profissional que produz bolos, doces, tortas e sobremesas',
    cnae: '5620-1/04',
    cnaes_secundarios: ['1091-1/02'],
    categoria: 'Alimentação',
    faturamento_medio: 'R$ 3.000 a R$ 12.000/mês',
    investimento_inicial: 'R$ 2.000 a R$ 20.000',
    servicos: ['Bolos decorados', 'Bolos de aniversário', 'Doces finos', 'Tortas', 'Cupcakes'],
    equipamentos: ['Forno', 'Batedeira', 'Formas', 'Utensílios de confeitaria', 'Embalagens'],
    dicas: [
      'Invista em cursos de cake design e tendências',
      'Fotos profissionais aumentam muito as vendas',
      'Crie encomendas recorrentes para datas especiais'
    ],
    faq: [
      { p: 'Confeiteiro pode ser MEI?', r: 'Sim! Confeiteiro se enquadra no CNAE 5620-1/04 para MEI.' },
      { p: 'Confeiteiro MEI pode vender pela internet?', r: 'Sim, pode vender por redes sociais, WhatsApp e delivery.' },
      { p: 'Preciso de vigilância sanitária como MEI?', r: 'Depende da cidade. Verifique as exigências locais.' }
    ]
  },
  
  'pizzaiolo': {
    titulo: 'Pizzaiolo',
    descricao: 'Profissional especializado na produção de pizzas',
    cnae: '5611-2/03',
    cnaes_secundarios: ['5620-1/04'],
    categoria: 'Alimentação',
    faturamento_medio: 'R$ 4.000 a R$ 15.000/mês',
    investimento_inicial: 'R$ 5.000 a R$ 40.000',
    servicos: ['Pizzas tradicionais', 'Pizzas gourmet', 'Pizzas doces', 'Eventos'],
    equipamentos: ['Forno de pizza', 'Masseira', 'Utensílios', 'Balcão refrigerado'],
    dicas: [
      'Diferencie-se com sabores exclusivos e ingredientes premium',
      'Delivery é essencial - parceria com apps ou entrega própria',
      'Invista em embalagens que mantenham a qualidade da pizza'
    ],
    faq: [
      { p: 'Pizzaiolo pode ser MEI?', r: 'Sim! Pizzaria se enquadra no CNAE 5611-2/03.' },
      { p: 'Quanto fatura uma pizzaria MEI?', r: 'Em média R$ 4.000 a R$ 15.000/mês.' },
      { p: 'Posso fazer pizza em casa e vender como MEI?', r: 'Sim, mas verifique as normas sanitárias da sua cidade.' }
    ]
  },
  
  'marmitex': {
    titulo: 'Marmitex / Marmita',
    descricao: 'Profissional que produz e vende refeições prontas para entrega',
    cnae: '5620-1/04',
    cnaes_secundarios: [],
    categoria: 'Alimentação',
    faturamento_medio: 'R$ 3.000 a R$ 10.000/mês',
    investimento_inicial: 'R$ 2.000 a R$ 15.000',
    servicos: ['Marmitas tradicionais', 'Marmitas fit', 'Marmitas congeladas', 'Refeições empresariais'],
    equipamentos: ['Fogão industrial', 'Panelas grandes', 'Embalagens', 'Freezer'],
    dicas: [
      'Ofereça cardápio variado semanal para fidelizar clientes',
      'Trabalhe com assinaturas semanais e mensais',
      'Invista em embalagens que mantêm a temperatura'
    ],
    faq: [
      { p: 'Vender marmitex pode ser MEI?', r: 'Sim! Fornecimento de alimentos preparados se enquadra no CNAE 5620-1/04.' },
      { p: 'Quanto cobra por marmita?', r: 'Valores variam de R$ 15 a R$ 35 dependendo do tamanho e região.' },
      { p: 'Preciso de cozinha industrial?', r: 'Não obrigatoriamente, mas deve seguir normas de higiene e segurança alimentar.' }
    ]
  },

  // =====================================================
  // CONSTRUÇÃO E MANUTENÇÃO
  // =====================================================
  'eletricista': {
    titulo: 'Eletricista',
    descricao: 'Profissional que realiza instalações e manutenções elétricas residenciais e comerciais',
    cnae: '4321-5/00',
    cnaes_secundarios: [],
    categoria: 'Construção e Manutenção',
    faturamento_medio: 'R$ 3.500 a R$ 12.000/mês',
    investimento_inicial: 'R$ 2.000 a R$ 10.000',
    servicos: ['Instalação elétrica', 'Manutenção preventiva', 'Troca de fiação', 'Instalação de chuveiro', 'Quadro de força'],
    equipamentos: ['Multímetro', 'Alicates', 'Chaves', 'Furadeira', 'EPI completo'],
    dicas: [
      'Obtenha certificações como NR-10 para aumentar credibilidade',
      'Ofereça orçamentos gratuitos para conquistar clientes',
      'Especialize-se em automação residencial - área em crescimento'
    ],
    faq: [
      { p: 'Eletricista pode ser MEI?', r: 'Sim! Eletricista de instalações prediais se enquadra no CNAE 4321-5/00.' },
      { p: 'Eletricista MEI precisa de curso?', r: 'Não é obrigatório para abrir MEI, mas curso técnico e NR-10 são muito recomendados.' },
      { p: 'Quanto cobra um eletricista MEI?', r: 'Diárias variam de R$ 150 a R$ 400, dependendo do serviço e região.' }
    ]
  },
  
  'encanador': {
    titulo: 'Encanador',
    descricao: 'Profissional de instalações e reparos hidráulicos em residências e empresas',
    cnae: '4322-3/01',
    cnaes_secundarios: [],
    categoria: 'Construção e Manutenção',
    faturamento_medio: 'R$ 3.000 a R$ 10.000/mês',
    investimento_inicial: 'R$ 1.500 a R$ 8.000',
    servicos: ['Instalação hidráulica', 'Desentupimento', 'Troca de torneiras', 'Reparo de vazamentos', 'Caixa dágua'],
    equipamentos: ['Chaves de encanador', 'Furadeira', 'Serra copo', 'Equipamentos de solda', 'EPI'],
    dicas: [
      'Ofereça serviço de emergência 24h - cobra mais e fideliza',
      'Faça parcerias com síndicos de condomínios',
      'Invista em equipamentos modernos para desentupimento'
    ],
    faq: [
      { p: 'Encanador pode ser MEI?', r: 'Sim! Encanador se enquadra no CNAE 4322-3/01 para MEI.' },
      { p: 'Quanto ganha um encanador MEI?', r: 'Faturamento médio de R$ 3.000 a R$ 10.000/mês.' },
      { p: 'Encanador MEI precisa de alvará?', r: 'O MEI geralmente tem dispensa simplificada de alvará.' }
    ]
  },
  
  'pedreiro': {
    titulo: 'Pedreiro',
    descricao: 'Profissional de construção civil para obras, reformas e reparos',
    cnae: '4399-1/03',
    cnaes_secundarios: [],
    categoria: 'Construção e Manutenção',
    faturamento_medio: 'R$ 3.000 a R$ 10.000/mês',
    investimento_inicial: 'R$ 1.000 a R$ 5.000',
    servicos: ['Construção', 'Reforma', 'Acabamento', 'Reboco', 'Contrapiso', 'Assentamento de pisos'],
    equipamentos: ['Colher de pedreiro', 'Nível', 'Prumo', 'Carrinho de mão', 'EPI completo'],
    dicas: [
      'Especialize-se em acabamento - paga mais que obra bruta',
      'Trabalhe com indicações e construa reputação',
      'Registre seus trabalhos em fotos para mostrar qualidade'
    ],
    faq: [
      { p: 'Pedreiro pode ser MEI?', r: 'Sim! Pedreiro se enquadra no CNAE 4399-1/03.' },
      { p: 'Quanto cobra um pedreiro MEI por dia?', r: 'Diárias variam de R$ 150 a R$ 300 dependendo da região.' },
      { p: 'Pedreiro MEI pode contratar ajudante?', r: 'Sim! O MEI pode ter até 1 funcionário registrado.' }
    ]
  },
  
  'pintor': {
    titulo: 'Pintor',
    descricao: 'Profissional de pintura residencial, comercial e industrial',
    cnae: '4330-4/04',
    cnaes_secundarios: [],
    categoria: 'Construção e Manutenção',
    faturamento_medio: 'R$ 2.500 a R$ 8.000/mês',
    investimento_inicial: 'R$ 500 a R$ 3.000',
    servicos: ['Pintura residencial', 'Pintura comercial', 'Textura', 'Grafiato', 'Verniz', 'Efeitos decorativos'],
    equipamentos: ['Rolos de pintura', 'Pincéis', 'Escadas', 'Lona de proteção', 'Compressor (opcional)'],
    dicas: [
      'Ofereça serviço de consultoria de cores aos clientes',
      'Trabalhe com produtos de qualidade - resultado é melhor',
      'Mantenha portfólio de antes e depois dos trabalhos'
    ],
    faq: [
      { p: 'Pintor pode ser MEI?', r: 'Sim! Pintor de obras se enquadra no CNAE 4330-4/04.' },
      { p: 'Quanto cobra um pintor por m²?', r: 'Valores variam de R$ 8 a R$ 25 por m² dependendo do acabamento.' },
      { p: 'Pintor MEI emite nota fiscal?', r: 'Sim! Pode e deve emitir nota fiscal, especialmente para empresas.' }
    ]
  },

  // =====================================================
  // TRANSPORTE
  // =====================================================
  'motorista-de-app': {
    titulo: 'Motorista de Aplicativo',
    descricao: 'Motorista parceiro de plataformas como Uber, 99 e outras',
    cnae: '4923-0/01',
    cnaes_secundarios: [],
    categoria: 'Transporte',
    faturamento_medio: 'R$ 3.000 a R$ 8.000/mês',
    investimento_inicial: 'R$ 0 (carro próprio ou alugado)',
    servicos: ['Transporte de passageiros', 'Corridas por aplicativo', 'Viagens intermunicipais'],
    equipamentos: ['Veículo habilitado na plataforma', 'Smartphone', 'Suporte de celular', 'Carregador veicular'],
    dicas: [
      'Trabalhe nos horários de pico para maximizar ganhos',
      'Mantenha o carro sempre limpo e com ar-condicionado funcionando',
      'Planeje rotas para economizar combustível'
    ],
    faq: [
      { p: 'Motorista de Uber pode ser MEI?', r: 'Sim! Motorista de app se enquadra no CNAE 4923-0/01 - Transporte de passageiros.' },
      { p: 'Uber exige MEI para motoristas?', r: 'Não é obrigatório, mas ter MEI permite emitir nota fiscal e ter benefícios do INSS.' },
      { p: 'Quanto paga de imposto motorista MEI?', r: 'Apenas o DAS mensal de aproximadamente R$ 75,90 - muito menos que autônomo.' }
    ]
  },
  
  'motoboy': {
    titulo: 'Motoboy / Entregador',
    descricao: 'Profissional que realiza entregas e delivery de produtos e documentos',
    cnae: '5320-2/02',
    cnaes_secundarios: [],
    categoria: 'Transporte',
    faturamento_medio: 'R$ 2.500 a R$ 7.000/mês',
    investimento_inicial: 'R$ 500 a R$ 3.000',
    servicos: ['Entregas de delivery', 'Entregas expressas', 'Transporte de documentos', 'Coletas'],
    equipamentos: ['Moto', 'Bag térmica', 'Capacete', 'Smartphone com GPS'],
    dicas: [
      'Cadastre-se em múltiplas plataformas para ter mais corridas',
      'Trabalhe nos horários de maior demanda (almoço e jantar)',
      'Mantenha a moto sempre em dia para evitar paradas'
    ],
    faq: [
      { p: 'Motoboy pode ser MEI?', r: 'Sim! Entregador se enquadra no CNAE 5320-2/02.' },
      { p: 'Preciso de CNPJ para fazer entregas?', r: 'Não é obrigatório, mas com MEI você tem benefícios do INSS.' },
      { p: 'Quanto ganha um motoboy MEI?', r: 'Em média R$ 2.500 a R$ 7.000/mês trabalhando full time.' }
    ]
  },

  // =====================================================
  // TECNOLOGIA
  // =====================================================
  'programador': {
    titulo: 'Programador / Desenvolvedor',
    descricao: 'Profissional de desenvolvimento de software, sistemas e aplicativos',
    cnae: '6201-5/01',
    cnaes_secundarios: ['6204-0/00'],
    categoria: 'Tecnologia',
    faturamento_medio: 'R$ 5.000 a R$ 15.000/mês',
    investimento_inicial: 'R$ 3.000 a R$ 10.000',
    servicos: ['Desenvolvimento de sites', 'Sistemas web', 'Aplicativos', 'Manutenção de software', 'APIs'],
    equipamentos: ['Computador potente', 'Internet de alta velocidade', 'Software e licenças', 'Monitor extra'],
    dicas: [
      'Especialize-se em uma tecnologia com alta demanda no mercado',
      'Construa portfólio com projetos no GitHub',
      'Trabalhe como freelancer em plataformas internacionais para ganhar em dólar'
    ],
    faq: [
      { p: 'Programador pode ser MEI?', r: 'Sim! Desenvolvimento de software se enquadra no CNAE 6201-5/01.' },
      { p: 'Vale a pena ser MEI como programador?', r: 'Sim, especialmente se faturar até R$ 81.000/ano. Impostos são muito menores.' },
      { p: 'Programador MEI pode emitir nota?', r: 'Sim! Pode emitir nota fiscal para empresas no Brasil e exterior.' }
    ]
  },
  
  'designer-grafico': {
    titulo: 'Designer Gráfico',
    descricao: 'Profissional de criação visual, identidade de marca e materiais gráficos',
    cnae: '7410-2/99',
    cnaes_secundarios: [],
    categoria: 'Tecnologia',
    faturamento_medio: 'R$ 3.000 a R$ 12.000/mês',
    investimento_inicial: 'R$ 3.000 a R$ 8.000',
    servicos: ['Identidade visual', 'Social media', 'Materiais impressos', 'Embalagens', 'Apresentações'],
    equipamentos: ['Computador', 'Mesa digitalizadora', 'Adobe Creative Cloud ou similar'],
    dicas: [
      'Monte um portfólio profissional no Behance e Dribbble',
      'Ofereça pacotes mensais de social media para renda recorrente',
      'Especialize-se em um nicho de mercado'
    ],
    faq: [
      { p: 'Designer gráfico pode ser MEI?', r: 'Sim! Design se enquadra no CNAE 7410-2/99.' },
      { p: 'Designer MEI precisa de diploma?', r: 'Não! Não é exigido diploma para atuar como designer MEI.' },
      { p: 'Quanto cobra um designer MEI?', r: 'Projetos variam de R$ 300 (artes simples) a R$ 5.000+ (identidade visual completa).' }
    ]
  },
  
  'fotografo': {
    titulo: 'Fotógrafo(a)',
    descricao: 'Profissional de fotografia de eventos, ensaios, produtos e corporativo',
    cnae: '7420-0/01',
    cnaes_secundarios: [],
    categoria: 'Tecnologia',
    faturamento_medio: 'R$ 3.000 a R$ 15.000/mês',
    investimento_inicial: 'R$ 5.000 a R$ 30.000',
    servicos: ['Ensaios fotográficos', 'Casamentos', 'Aniversários', 'Fotografia de produtos', 'Fotos corporativas'],
    equipamentos: ['Câmera DSLR ou Mirrorless', 'Lentes variadas', 'Flash', 'Computador', 'Software de edição'],
    dicas: [
      'Especialize-se em um tipo de fotografia para se destacar',
      'Invista em equipamentos de qualidade gradualmente',
      'Monte portfólio forte no Instagram e site próprio'
    ],
    faq: [
      { p: 'Fotógrafo pode ser MEI?', r: 'Sim! Fotografia se enquadra no CNAE 7420-0/01.' },
      { p: 'Quanto cobra um fotógrafo MEI?', r: 'Eventos: R$ 1.000 a R$ 5.000. Ensaios: R$ 300 a R$ 1.500.' },
      { p: 'Preciso de curso para ser fotógrafo MEI?', r: 'Não é obrigatório, mas cursos melhoram muito a qualidade.' }
    ]
  },
  
  'social-media': {
    titulo: 'Social Media',
    descricao: 'Profissional de gestão de redes sociais e marketing digital para empresas',
    cnae: '6319-4/00',
    cnaes_secundarios: ['7319-0/02'],
    categoria: 'Tecnologia',
    faturamento_medio: 'R$ 3.000 a R$ 10.000/mês',
    investimento_inicial: 'R$ 1.000 a R$ 5.000',
    servicos: ['Gestão de redes sociais', 'Criação de conteúdo', 'Planejamento de posts', 'Relatórios de métricas'],
    equipamentos: ['Computador', 'Smartphone bom', 'Ferramentas de agendamento', 'Canva Pro'],
    dicas: [
      'Especialize-se em um nicho de mercado específico',
      'Use ferramentas de automação para ganhar escala',
      'Mostre resultados com métricas claras aos clientes'
    ],
    faq: [
      { p: 'Social Media pode ser MEI?', r: 'Sim! Se enquadra no CNAE 6319-4/00 ou 7319-0/02.' },
      { p: 'Quanto cobra um social media MEI?', r: 'Pacotes mensais variam de R$ 500 a R$ 3.000 por cliente.' },
      { p: 'Quantos clientes um social media consegue atender?', r: 'Em média 5 a 15 clientes, dependendo do escopo do trabalho.' }
    ]
  },

  // =====================================================
  // EDUCAÇÃO
  // =====================================================
  'professor-particular': {
    titulo: 'Professor Particular',
    descricao: 'Profissional de aulas particulares, reforço escolar e preparação para provas',
    cnae: '8599-6/04',
    cnaes_secundarios: [],
    categoria: 'Educação',
    faturamento_medio: 'R$ 2.000 a R$ 8.000/mês',
    investimento_inicial: 'R$ 500 a R$ 2.000',
    servicos: ['Aulas particulares', 'Reforço escolar', 'Preparatório para vestibular', 'Aulas online'],
    equipamentos: ['Computador', 'Material didático', 'Internet de qualidade', 'Webcam'],
    dicas: [
      'Especialize-se em uma matéria ou vestibular específico',
      'Ofereça aulas online para ampliar seu alcance geográfico',
      'Crie material didático próprio para se diferenciar'
    ],
    faq: [
      { p: 'Professor particular pode ser MEI?', r: 'Sim! Instrutor de cursos livres se enquadra no CNAE 8599-6/04.' },
      { p: 'Quanto cobrar por aula particular?', r: 'Valores variam de R$ 50 a R$ 200 por hora dependendo da matéria.' },
      { p: 'Professor MEI pode dar aula online?', r: 'Sim! Pode dar aulas presenciais e online normalmente.' }
    ]
  },

  // =====================================================
  // SERVIÇOS DOMÉSTICOS
  // =====================================================
  'diarista': {
    titulo: 'Diarista / Faxineira',
    descricao: 'Profissional de limpeza e serviços domésticos em residências e escritórios',
    cnae: '9700-5/00',
    cnaes_secundarios: [],
    categoria: 'Serviços Domésticos',
    faturamento_medio: 'R$ 2.000 a R$ 5.000/mês',
    investimento_inicial: 'R$ 200 a R$ 500',
    servicos: ['Faxina residencial', 'Limpeza pós-obra', 'Limpeza comercial', 'Passadoria'],
    equipamentos: ['Produtos de limpeza', 'Panos e baldes', 'Aspirador de pó (opcional)'],
    dicas: [
      'Trabalhe com agendamento fixo semanal para ter renda previsível',
      'Ofereça diferenciais como organização de ambientes',
      'Invista em produtos de limpeza de qualidade'
    ],
    faq: [
      { p: 'Diarista pode ser MEI?', r: 'Sim! Serviços domésticos se enquadram no CNAE 9700-5/00.' },
      { p: 'Diarista MEI tem direito a benefícios?', r: 'Sim! Pagando o DAS, tem direito a aposentadoria, auxílio-doença, salário-maternidade e outros.' },
      { p: 'Quanto cobra uma diarista MEI?', r: 'Diárias variam de R$ 120 a R$ 250 dependendo da cidade e tamanho da residência.' }
    ]
  },

  // =====================================================
  // EVENTOS
  // =====================================================
  'dj': {
    titulo: 'DJ',
    descricao: 'Profissional de discotecagem para festas, eventos e casamentos',
    cnae: '9001-9/02',
    cnaes_secundarios: [],
    categoria: 'Eventos',
    faturamento_medio: 'R$ 3.000 a R$ 15.000/mês',
    investimento_inicial: 'R$ 3.000 a R$ 20.000',
    servicos: ['Festas de aniversário', 'Casamentos', 'Formaturas', 'Eventos corporativos', 'Baladas'],
    equipamentos: ['Controladora DJ', 'Notebook', 'Caixas de som', 'Iluminação', 'Microfone'],
    dicas: [
      'Especialize-se em um estilo musical ou tipo de evento',
      'Invista em equipamentos de qualidade - faz diferença no som',
      'Construa presença forte nas redes sociais'
    ],
    faq: [
      { p: 'DJ pode ser MEI?', r: 'Sim! DJ se enquadra no CNAE 9001-9/02 - Produção musical.' },
      { p: 'Quanto cobra um DJ MEI?', r: 'Eventos variam de R$ 500 a R$ 5.000 dependendo do tipo e duração.' },
      { p: 'DJ MEI pode emitir nota fiscal?', r: 'Sim! E é importante para fechar contratos com empresas e buffets.' }
    ]
  },
  
  'decorador': {
    titulo: 'Decorador(a)',
    descricao: 'Profissional de decoração para festas, eventos e ambientes',
    cnae: '9001-9/99',
    cnaes_secundarios: [],
    categoria: 'Eventos',
    faturamento_medio: 'R$ 3.000 a R$ 12.000/mês',
    investimento_inicial: 'R$ 2.000 a R$ 15.000',
    servicos: ['Decoração de festas', 'Decoração de casamentos', 'Cenografia', 'Ambientação'],
    equipamentos: ['Materiais decorativos', 'Balões', 'Tecidos', 'Iluminação decorativa', 'Estruturas'],
    dicas: [
      'Monte um estoque variado de materiais para diferentes temas',
      'Fotografe todos os trabalhos para compor portfólio',
      'Trabalhe com temas personalizados para se diferenciar'
    ],
    faq: [
      { p: 'Decorador pode ser MEI?', r: 'Sim! Decoração se enquadra no CNAE 9001-9/99.' },
      { p: 'Quanto cobra um decorador MEI?', r: 'Festas simples: R$ 500 a R$ 2.000. Casamentos: R$ 3.000 a R$ 15.000.' },
      { p: 'Preciso de curso para ser decorador MEI?', r: 'Não é obrigatório, mas cursos agregam conhecimento e credibilidade.' }
    ]
  },

  // =====================================================
  // PETS
  // =====================================================
  'pet-sitter': {
    titulo: 'Pet Sitter',
    descricao: 'Profissional que cuida de animais de estimação na ausência dos donos',
    cnae: '9609-2/08',
    cnaes_secundarios: [],
    categoria: 'Pets',
    faturamento_medio: 'R$ 2.000 a R$ 6.000/mês',
    investimento_inicial: 'R$ 500 a R$ 2.000',
    servicos: ['Hospedagem de pets', 'Visitas diárias', 'Passeios', 'Alimentação', 'Medicação'],
    equipamentos: ['Coleiras e guias', 'Caixas de transporte', 'Produtos de higiene pet'],
    dicas: [
      'Invista em cursos de comportamento animal',
      'Tire fotos e envie atualizações aos donos',
      'Tenha seguro para imprevistos com os pets'
    ],
    faq: [
      { p: 'Pet sitter pode ser MEI?', r: 'Sim! Cuidados com animais se enquadram no CNAE 9609-2/08.' },
      { p: 'Quanto cobra um pet sitter MEI?', r: 'Hospedagem: R$ 50 a R$ 150/dia. Passeios: R$ 30 a R$ 80.' },
      { p: 'Preciso de alvará para ser pet sitter?', r: 'Depende se você atende em casa própria. Verifique na sua cidade.' }
    ]
  },
  
  'dog-walker': {
    titulo: 'Dog Walker',
    descricao: 'Profissional especializado em passeios com cães',
    cnae: '9609-2/08',
    cnaes_secundarios: [],
    categoria: 'Pets',
    faturamento_medio: 'R$ 2.000 a R$ 5.000/mês',
    investimento_inicial: 'R$ 300 a R$ 1.000',
    servicos: ['Passeios diários', 'Passeios em grupo', 'Passeios individuais', 'Adestramento básico'],
    equipamentos: ['Coleiras e guias resistentes', 'Pochete para petiscos', 'Sacos para coleta', 'Bebedouro portátil'],
    dicas: [
      'Ofereça passeios em horários variados para diferentes perfis',
      'Documente os passeios com fotos para os donos',
      'Faça cursos de comportamento canino'
    ],
    faq: [
      { p: 'Dog walker pode ser MEI?', r: 'Sim! Passeios com cães se enquadram no CNAE 9609-2/08.' },
      { p: 'Quanto cobra um dog walker por passeio?', r: 'Valores variam de R$ 30 a R$ 80 por passeio de 30-60 minutos.' },
      { p: 'Quantos cães posso passear por vez?', r: 'Recomenda-se no máximo 5-6 cães por vez para segurança.' }
    ]
  },
  
  'tosador': {
    titulo: 'Tosador / Groomer',
    descricao: 'Profissional de tosa e estética animal para pets',
    cnae: '9609-2/08',
    cnaes_secundarios: [],
    categoria: 'Pets',
    faturamento_medio: 'R$ 2.500 a R$ 7.000/mês',
    investimento_inicial: 'R$ 2.000 a R$ 10.000',
    servicos: ['Tosa higiênica', 'Tosa na máquina', 'Tosa na tesoura', 'Banho', 'Hidratação de pelos'],
    equipamentos: ['Máquina de tosa', 'Tesouras profissionais', 'Secador', 'Mesa de tosa', 'Banheira'],
    dicas: [
      'Especialize-se em raças específicas',
      'Faça cursos de grooming profissional',
      'Ofereça pacotes mensais de manutenção'
    ],
    faq: [
      { p: 'Tosador pode ser MEI?', r: 'Sim! Serviços de estética animal se enquadram no CNAE 9609-2/08.' },
      { p: 'Quanto cobra um tosador MEI?', r: 'Tosa simples: R$ 50 a R$ 100. Tosa completa: R$ 80 a R$ 200.' },
      { p: 'Preciso de curso para ser tosador?', r: 'Não é obrigatório, mas cursos são essenciais para trabalho seguro.' }
    ]
  }
};

// Lista de todas as profissões disponíveis (para listagem)
export const listaProfissoes = Object.keys(profissoesData).map(slug => ({
  slug,
  ...profissoesData[slug]
}));

export default profissoesData;